import React from "react";
import { Container, Link, Title } from "../GeneralStyles/GeneralStyles";
import UserCircleImage from './Assets/UserCircle.svg';
import { SuccessIcon, SuccessParagraph, SuccessText } from "./Styled";
import { loginUrl } from "../../utils/env";

const ConfirmationSuccess = () => {
  return (
    <Container>
      <Title>Sign Up</Title>
      <SuccessParagraph>
        <SuccessIcon src={UserCircleImage} />
        <SuccessText>
          User has been created successfully!
        </SuccessText>
        <Link 
          href={loginUrl}
          target="_blank"
          tabIndex={0}
          style={{ color: "#1A4AF0", fontSize: '16px' }}
          aria-label="Go to login page" role="button"
        >
          Go to login
        </Link>
      </SuccessParagraph>
    </Container>
  );
};

export default ConfirmationSuccess;
